import { Api } from '@axiom/ui';
import type { Position } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class PositionsLegacyApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  async updatePosition(id: Position['id'], body: Partial<Position>) {
    return super.write<{ data: Position }>({
      endpoint: `/positions/${id}`,
      method: 'PATCH',
      body,
    });
  }

  async deletePosition(id: Position['id']) {
    return super.write<{ data: Position }>({
      endpoint: `/positions/${id}`,
      method: 'DELETE',
    });
  }
}

export const PositionsLegacyApi = new PositionsLegacyApiClass();
